'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyDropdown = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseDropdown = require('@bibliocommons/base-dropdown');

require('../styles/PropertyDropdown.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  handleListPropertyChange: _react2.default.PropTypes.func.isRequired,
  property: _react2.default.PropTypes.string.isRequired,
  options: _react2.default.PropTypes.object.isRequired,
  list: _bcPropTypes.listShape.isRequired,
  label: _react2.default.PropTypes.string
};

var PropertyDropdown = exports.PropertyDropdown = function (_BcReactComponent) {
  _inherits(PropertyDropdown, _BcReactComponent);

  function PropertyDropdown(props) {
    _classCallCheck(this, PropertyDropdown);

    var _this = _possibleConstructorReturn(this, (PropertyDropdown.__proto__ || Object.getPrototypeOf(PropertyDropdown)).call(this, props));

    _this.bindAll('handleSelect');
    return _this;
  }

  _createClass(PropertyDropdown, [{
    key: 'handleSelect',
    value: function handleSelect(value) {
      this.props.handleListPropertyChange(_immutable2.default.Map(_defineProperty({}, this.props.property, value)));
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          property = _props.property,
          label = _props.label;

      var options = this.props.options.map(function (k, v) {
        return {
          label: k,
          value: v
        };
      }).toIndexedSeq().toJS();

      return _react2.default.createElement(
        'div',
        { className: 'cp-user-list-property-dropdown', 'data-test-id': property + '-property-dropdown' },
        _react2.default.createElement(
          'div',
          { className: 'property-name', id: property + '-dropdown-label', htmlFor: property + '-dropdown' },
          label,
          ':'
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_baseDropdown.Dropdown, {
            selected: this.props.options.get(this.props.list.get(property)),
            dropdownMenuId: property + '-dropdown',
            labelledById: property + '-dropdown-label',
            options: options,
            className: 'btn-block',
            handleSelect: this.handleSelect,
            testId: 'property-dropdown-' + property })
        )
      );
    }
  }]);

  return PropertyDropdown;
}(_baseBcReactComponent2.default);

PropertyDropdown.propTypes = propTypes;

exports.default = PropertyDropdown;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/property-dropdown/components/PropertyDropdown.component.js
// module id = 1327
// module chunks = 0